@for (attribute of attributes; track attribute.code; let isFirst = $first) {
@switch (displayDropdown(attribute.code)) {
@default {
<div
     [ngClass]="{'bg-col-5-s m-l--4-s m-r--4-s p-l-4-s p-r-4-s p-t-5-s p-b-5-s bg-col-5-m m-l--4-m m-r--4-m p-l-4-m p-r-4-m p-t-5-m p-b-5-m': !attribute.model.data?.isSwatch, 'm-t-7 m-t-5-s m-t-5-m' : !isFirst }">
    @if (!attribute.hidden) {
    <!-- title line -->
    <h6 class="p1"
        [ngClass]="(isErrorVisible && configurableError?.attribute === attribute.code) ? 'col-2' : ''">
        @switch (hasSelection(attribute)) {
        @case (true) {
        {{ attribute.model.data?.label }}: {{ getSelection(attribute) | optionLabel : attribute.code }}
        }
        <!-- unselected -->
        @default {
        {{ 'Select %' | translate : attribute.model.data?.label }}
        }
        }
        <!-- selected -->
    </h6>
    @switch (attribute.model.data?.isSwatch) {
    <!-- swatches -->
    @case (true) {
    <div class="m-t-1">
        @for (option of sortedAttributesOptions(attribute.code, attribute.options); track $index) {
        <swatch class="inline-block va-m cursor-pointer m-r-1"
                [class.is-oos]="!option.salable"
                [option]="option"
                [configurableOptionWarningTrigger]="{ attribute: attribute, option: option }"
                [selected]="isPicked(attribute, option)"
                (click)="pick(attribute, option)"></swatch>
        }
    </div>
    }
    <!-- regular options  -->
    @default {
    <div>
        <div class="m-t-1 b-a flex flex-wrap"
             [style.maxWidth]="'fit-content'"
             [style.gap.rem]="0.2"
             [ngClass]="isErrorVisible && configurableError?.attribute === attribute.code ? 'b-col-2' : 'b-col-t'">
            @for (option of attribute.options; track $index) {
            <box class="inline-block va-m cursor-pointer"
                 [configurableOptionWarningTrigger]="{ attribute: attribute, option: option }"
                 [selected]="isPicked(attribute, option)"
                 [disabled]="isDisabled(option)"
                 [warning]="hasWarning(option)"
                 (click)="pick(attribute, option)">
                {{option.label}}
            </box>
            }
        </div>
        @if (isErrorVisible && configurableError?.attribute === attribute.code) {
        <p class="m-t-2 col-2"
           [style.minHeight.rem]="1">
            {{ 'Please select a %' | translate : attribute.model.data?.label?.toLowerCase()}}
        </p>
        }
    </div>
    }
    }
    }
    <!-- size guide -->
    @if (hasSizeGuide(attribute)) {
    <button class="block m-t-2 m-t-3-s m-t-3-m button-inline-2"
            (click)="openSizeGuide()">
        <span class="button__body"
              sizeClass="SM: col-1; XL: col-11">{{'View size guide' | translate}}</span>
    </button>
    }
</div>
}
@case (true) {
<div class="w-12"
     [ngClass]="isAttributeMultiple(attribute.code) ? 'm-t-2' : 'm-t-7 m-t-2-s m-t-2-m'">
    <!-- size guide -->
    @if (hasSizeGuide(attribute)) {
    <div class="w-12 right">
        <button class="inline-block p2 underline italic"
                [sizeClass]="'SM: col-11, XL: col-1'"
                [ngClass]="{'m-b m-b-2-s m-b-2-m' : isAttributeMultiple(attribute.code)}"
                style="text-decoration-color: currentColor;"
                (click)="openSizeGuide()">{{'View size guide' | translate}}
        </button>
    </div>
    }
    <product-configurable-option-dropdown [value]="getOption(attribute.code, getSelection(attribute) || 0)"
                                          [multipleVariant]="isAttributeMultiple(attribute.code)"
                                          [displayWarnings]="displayDropdownWarnings"
                                          (valueChange)="pick(attribute, $event)"
                                          class="block"
                                          [attr]="attribute"
                                          [ngClass]=" isAttributeMultiple(attribute.code) ? 'm-t-1' : 'm-t-3 m-t-2-s m-t-2-m'">
        <!-- mobile button or size guide -->
        @if (hasSizeGuide(attribute)) {
        <button class="inline-block p2 underline italic col-11"
                style="text-decoration-color: currentColor;"
                (click)="openSizeGuide()">{{'View size guide' | translate}}
        </button>
        }
    </product-configurable-option-dropdown>

    <sizebay #sizebayRef></sizebay>
</div>
}
}
}
